import React from 'react';
import { ReviewQuestionHeader } from './ReviewQuestionHeader';
import ReportSoalButton from '../../../LanguageLearning/ReportSoalButton';
import RecapSection from '../RecapSection';

/**
 * Shared wrapper component for all review question types
 * Handles common structure: container, header, content, explanation, recap
 */
export function ReviewQuestionWrapper({ 
  questionType, 
  question, 
  explanation = '', 
  recap = '', 
  annotations = [],
  reportProps = null,
  children 
}) {
  const reportSlot = reportProps ? (
    <ReportSoalButton
      type={reportProps.reportType}
      prosetId={reportProps.prosetId}
      soalId={reportProps.soalId}
      allowReReport={true}
      persistReportedState={true}
      reportText="Report this question"
    />
  ) : null;

  return (
    <div className="bg-[var(--card-bg)] rounded-xl p-4 mb-4 max-xl:px-3 max-xl:py-3 xl:p-6 xl:mb-6">
      <ReviewQuestionHeader
        questionType={questionType}
        reportSlot={reportSlot}
        currentQuestionNumber={reportProps?.currentQuestionNumber}
        totalQuestions={reportProps?.totalQuestions}
        score={reportProps?.score}
      />
      
      <div className="flex flex-col gap-5">
        {children}
        
        {/* Explanation - di atas recap */}
        {explanation && (
          <div className="bg-[linear-gradient(135deg,#fff9e6_0%,#ffeaa7_100%)] dark:bg-[linear-gradient(135deg,#3d3520_0%,#4a3d1a_100%)] p-5 rounded-xl mb-6 border-l-4 border-l-[#ffd93d]">
            <h3 className="text-base font-bold text-amber-600 dark:text-amber-400 mb-3 flex items-center gap-2">Penjelasan</h3>
            <p className="text-[15px] text-[var(--text-primary)] leading-relaxed m-0">{explanation}</p>
          </div>
        )}

        <RecapSection recap={recap} annotations={annotations} question={question} />
      </div>
    </div>
  );
}

